module.exports = __webpack_public_path__ + "static/media/no_invoice.5411c7e4.png";